export default {
  language: 'Русский',
  month: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
  days: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
  interface: {
    selfAssign: 'Оставьте это поле пустым, <br> чтобы назначить себя',
    chooseEmployee: 'Выберите сотрудника',
    chooseSource: 'Выберите источник',
    chooseSender: 'Выберите отправителя',
    chooseDocument: 'Выберите документ',
    addExternalOrganization: 'Добавить внешнюю организацию',
    termCases: {
      progress: 'Срок истекает',
      done: 'Срок истек',
      unknown: 'Срок истек(ает)',
    },
    search: 'Искать...',
    preview: 'Предпросмотр',
    advancedSearch: 'Расширенный поиск',
    all: 'Все',
    authored: 'Я автор',
    maintained: 'Я отвественный',
    executed: 'Я исполнитель',
    expired: 'С истекшим сроком',
    expiring: 'Срок не истек',
    without_term: 'Без срока',
    apply: 'Применить',
    accept: 'Принять',
    checked: 'Проверено',
    cancel: 'Отменить',
    send: 'Отправить',
    clearFilters: 'Очистить фильтр',
    nothingFound: 'Ничего не найдено, попробуйте',
    resetFiltersAndSearch: 'сбросить фильтры и поиск',
    edit: 'Редактировать',
    publish: 'Опубликовать',
    startExecution: 'Приступить к исполнению',
    endExecution: 'Завершить исполнение',
    information: 'Информация',
    inputNote: 'Введите примечание',
    rejectNote: 'Укажите причину возврата',
    description: 'Описание',
    fileDeletingAcceptation: 'Вы уверены что хотите удалить файл?',
    fileSuccessfulDeleted: 'Файл успешно удален',
    areYouSureRemove: 'Вы уверены, что хотите удалить данный объект безвозвратно?',
    confirm: 'Подтвердите действие',
    remove: 'Удалить',
    exportExcel: 'Экспотировать в Excel',
    date: 'Дата',
    save: 'Сохранить',
    allEmployees: 'Для всех сотрудников',
    requiredFields: 'Введите все обязательные поля, со знаком *',
    allRequired: 'Все поля обязательны к заполнению',
    changeTerm: 'Изменть срок',
    applicantDocumentId: 'Идентификатор заявителя',
    employeeSelectTip: `Выделите сотрудников, которым будет доступен данный опрос. <br>
                        Для того, чтобы выбрать одного или несколько сотрудников нажмите на них, 
                        удерживая при этом клавишу
                        <span class="kbd">Ctrl</span> или <span class="kbd">Shift</span>.`,
    uploadFile: 'Загрузить файл',
    noFiles: 'Нет файлов для отображения.',
    noInternet: 'Интернет соединение отсутсвует',
    checkInternet: 'Проверьте ваше интернет соединение.',
    noFileSelected: 'Файл не выбран',
    historyBack: 'Назад',
    employeeChoose: 'Выберите сотрудника',
    globalSearchPlaceholder: 'Поиск документов, поручений и сотрудников...',
    selectSource: 'Выберите источник',
    time: 'Время',
    notifications: 'Оповещения',
    notificationsEmpty: 'Нет новых оповещений.',
    reject: 'Отклонить',
    return: 'Вернуть',
    restore: 'Вернуть на исполнение',
    noTimelineActions: 'Действий для отображения нет.',
    welcome: 'Добро пожаловать,',
    myProfile: 'Мой профиль',
    profileSettings: 'Настройки профиля',
    exit: 'Выход',
    removeSelected: 'Удалить выделенные',
    dataDeleting: 'Удалить данные ',
    dataDeletingMessage: 'Вы уверены что хотите удалить эти данные?',
    start_date: 'Начало',
    end_date: 'Конец',
    export: 'Экспорт',
    card: 'Карточка',
    downloadDocument: 'Скачать документ',
    registerCard: 'Контрольный лист',
    downloadInstruction: 'Инструкция',
    changePassword: 'Сменить пароль',
    passwordsNotMatch: 'Введеные пароли не совпадают',
    old_password: 'Текущий пароль',
    new_password: 'Новый пароль',
    repeat_password: 'Повторите новый пароль',
    password_changed: 'Пароль успешно изменен',
    createNewObject: 'Создать новый объект',
    hide: 'скрыть',
    dragDropFiles: 'Отпустите файл в данной области, чтобы загрузить',
    confirmFileUpload: 'Вы уверены, что хотите загрузить данный файл?',
    dragDropNote: 'Перетащите файл в браузер, чтобы загрузить',
    generalDocument: 'Файл документа',
    allDocumentsTemplate: 'Шаблон для всех документов',
    orderTemplate: 'Шаблон для приказа',
    y: 'Да',
    n: 'Нет',
  },
  routes: {
    documents: 'Поручения',
    globalSearch: 'Поиск',
    docflowIncoming: 'Входящие',
    docflowOutgoing: 'Исходящие',
    createResolution: 'Создание резолюции',
    editResolution: 'Изменение резолюции',
    createDocument: 'Новое поручение',
    createPlanItem: 'Новый пункт плана мероприятий',
    createPlanGroup: 'Новый группа плана мероприятий',
    editPlanGroup: 'Изменение группы плана мероприятий',
    editPlanItem: 'Изменение пункта плана мероприятий',
    editDocument: 'Изменение поручения',
    documentDetail: 'Просмотр поручения',
    docflowPlanItemDetail: 'Исполнители',
    createTask: 'Новая задача',
    editTask: 'Изменение задачи',
    taskDetail: 'Задача',
    projects: 'Проекты',
    createProject: 'Новый проект',
    editProject: 'Изменение проекта',
    projectDetail: 'Проект',
    createPhase: 'Новая фаза',
    editPhase: 'Изменение фазы',
    createContractor: 'Новый подрядчик',
    editContractor: 'Изменение подрядчика',
    createSpending: 'Новое освоение средств',
    editSpending: 'Изменение освоения средств',
    createFinancingSource: 'Новый источник финансирования',
    editFinancingSource: 'Изменение источника финансирования',
    createIssue: 'Новый вопрос по проекту',
    editIssue: 'Изменение вопроса по проекту',
    departments: 'Подразделения',
    departmentDetail: 'Просмотр подразделения',
    issues: 'Заявки',
    createIssueTracker: 'Новая заявка',
    editIssueTracker: 'Редактирование заявки',
    issueDetail: 'Просмотр заявки',
    reportsList: 'Отчеты',
    userReport: 'Пользовательский отчет',
    employeeExecutionReport: 'Отчет по исполнению поручениям',
    employeesOverdueDocumentsByRegisterBooks: 'Просроченные документы (в разрезе картотек)',
    surveys: 'Опросы',
    surveyDetail: 'Просмотр опроса',
    surveyResults: 'Результаты опроса',
    createSurvey: 'Новый опрос',
    editSurvey: 'Редактирование опроса',
    resources: 'Ресурсы',
    createReservation: 'Резервирование',
    employeeDetail: 'Просмотр профиля',
    editEmployeeData: 'Редактирование профиля',
    announcements: 'Анонсы',
    createAnnouncement: 'Новый анонс',
    docflow: 'Документы',
    createDocflow: 'Новый документ',
    editDocflow: 'Редактирование документа',
    docflowDetail: 'Просмотр документа',
    docflowAgreementsList: 'Для согласования',
    docflowRegistrationsList: 'Для регистрации',
    dashboard: 'Главная',
    docflowRegister: 'Регистрация документа',
    docflowAppeals: 'Обращения граждан',
    manageDepartments: 'Список департаментов',
    createDepartments: 'Создать департамент',
    editDepartments: 'Изменить департамент',
    externalOrganizations: 'Внешние организации',
    createExternalOrganizations: 'Добавить внешнюю организацию',
    editExternalOrganizations: 'Изменить внешнюю организацию',
    positions: 'Штатная иерархия',
    createPosition: 'Добавить запись',
    editPosition: 'Изменить запись',
    postNames: 'Должности',
    createPostName: 'Добавить должность',
    editPostName: 'Изменить должность',
    registerBooks: 'Картотеки',
    createRegisterBook: 'Добавить картотеку',
    editRegisterBook: 'Изменить картотеку',
    documentTypes: 'Типы документов',
    createDocumentType: 'Добавить тип документа',
    editDocumentType: 'Изменить тип документа',
    deliveryTypes: 'Виды доставки',
    createDeliveryType: 'Добавить вид доставки',
    editDeliveryType: 'Изменить вид доставки',
    resourceCategories: 'Категории ресурсов',
    createResourceCategory: 'Создать категорию ресурсов',
    editResourceCategory: 'Изменить категорию ресурсов',
    manageResources: 'Ресурсы',
    createResource: 'Добавить ресурс',
    editResource: 'Изменить ресурс',
    employees: 'Сотрудники',
    createEmployee: 'Добавить сотрудника',
    editEmployee: 'Изменить сотрудника',
    issueCategories: 'Категории заявок',
    createIssueCategory: 'Добавить категорию заявок',
    editIssueCategory: 'Изменить категорию заявок',
    shortBySenders: 'Отчет по входящим и внутренним документам',
    expiringDocsByRegisterBooks: 'Отчет по документам с истекающим и истекшим сроком',
    changePassword: 'Сменить пароль',
    appealsByCategoriesAndRegions: 'Обращения по категориям и регионам',
    employeesDocsByState: 'Отчет по статусам документов в разрезе сотрудников',
    analyticsDashboard: 'Аналитическая панель',
    tasks: 'Задачи',
  },
  navigation: {
    service: 'Сервис',
    docflow: 'Документы',
    documents: 'Поручения',
    projects: 'Проекты',
    departments: 'Подразделения',
    issues: 'Заявки',
    globalSearch: 'Поиск',
    surveys: 'Опросы',
    resources: 'Ресурсы',
    reportsList: 'Отчеты',
    announcements: 'Анонсы',
    admin: 'Администрирование',
    employees: 'Сотрудники',
    manageDepartments: 'Подразделения',
    externalOrganizations: 'Внешние организации',
    positions: 'Штатная иерархия',
    postNames: 'Должности',
    cloud: 'Хранилище',
    docflowIncoming: 'Входящие',
    docflowOutgoing: 'Исходящие',
    docflowAppeals: 'Обращения',
    docflowAgreementsList: 'Для согласования',
    docflowRegistrationsList: 'Для регистрации',
    documentTypes: 'Типы документов',
    registerBooks: 'Картотеки',
    deliveryTypes: 'Виды доставки',
    resourceCategories: 'Категории ресурсов',
    manageResources: 'Ресурсы',
    dashboard: 'Рабочая среда',
    extendedDashboard: 'Рабочая среда',
    issueCategories: 'Категории заявок',
    analyticsDashboard: 'Аналитическая панель',
  },
  workflow: {
    doctypes: {
      info: 'Для сведения',
      task: 'Задание'
    },
    sourceTypes: {
      internal: 'Внутренний',
      external: 'Внешний'
    },
    priorities: {
      low: 'Низкий',
      medium: 'Средний',
      high: 'Высокий'
    },
    states: {
      draft: 'Черновик',
      new: 'Новый',
      in_process: 'В работе',
      done: 'Выполнен',
      rejected: 'Возвращен',
      closed: 'Закрыт',
      active: 'Активные',
      cancelled: 'Отменен',
      pending_resolution: 'В ожидании резолюции',
      pending_plan_agreement: 'Согласование ПМ',
      resolution_filled: 'Резолюция заполнена',
      resolution_approved: 'Резолюция утверждена',
      resolution_rejected: 'Резолюция возвращена',
      pending_checkout: 'На ознакомлении',
      pending_agreement: 'На согласовании',
      pending_closing: 'В ожидании закрытия',
      agreed: 'Согласован',
      approved: 'Утвержден',
      registration_number_attached: 'Зарегистрирован',
      published: 'Опубликован',
      executive_checking: 'В Аппарате исполенния',
    },
    changeStates: {
      pending_approve: 'Запрос на изменение',
      rejected: 'Запрос на изменение отклонен',
      approved: 'Запрос на изменение принят',
      done: 'Запрос на изменение выполнен',
    },
    maintainerTypes: {
      maintainer: 'Ответственный',
      executor: 'Соисполнитель'
    }
  },
  projectControl: {
    sourceTypes: {
      internal: 'Внутренний',
      external: 'Внешний'
    },
    contractorTypes: {
      planning: 'Разработка ТЭО',
      realization: 'Реализация'
    },
    states: {
      'new': 'Не начато',
      contractor_definition: 'Определение подрядчика',
      in_process: 'Исполняется',
      completed: 'Исполнено',
      cancelled: 'Отменено'
    },
    issueStatuses: {
      'new': 'Открытый вопрос',
      in_process: 'Решается',
      completed: 'Решено',
      cancelled: 'Отменено',
      paused: 'Приостановлено'
    }
  },
  notification: {
    verbs: {
      document_pending_resolution: 'Документ отправлен на заполнение резолюции',
      document_resolution_filled: 'Резолюция по документу заполнена',
      document_resolution_approved: 'Резолюция по документу утверждена',
      document_pending_checkout: 'Документ ожидает ознакомления',
      document_checked_out: 'Ознакомление с документом',
      document_checkout_rejected: 'Документ отклонен на стадии ознакомления',
      document_pending_agreement: 'Документ ожидает согласования',
      document_agreed: 'Документ согласован и ожидает утверждения',
      document_approved: 'Документ утвержден',
      document_published: 'Опубликован документ',
      document_in_process: 'Начато исполнение документа',
      document_pending_closing: 'Документ ожидает закрытия',
      document_closed: 'Работа по документу завершена',
      received_document_for_registration: 'Поступил документ для регистрации',
      assigned_to_assignment_as_maintainer: 'Назначен ответственным поручения',
      assigned_to_task_as_executor: 'Назначен исполнителем задачи',
      task_in_process: 'Начато исполнение задачи',
      task_done: 'Задача выполнена',
      task_closed: 'Задача закрыта',
      task_rejected: 'Результат задачи отклонен',
      task_cancelled: 'Задача отменена',
      assignment_closed: 'Поручение закрыто',
      assignment_cancelled: 'Поручение отменено',
      expiring_documents: 'Поручения с истекающим сроком',
      expiring_tasks: 'Задачи с истекающим сроком',
      survey_created: 'Опубликован новый опрос',
      announcement_created: 'Опубликован новое объявление',
      issue_created: 'Опубликована новая заявка',
      issue_in_process: 'Начато исполнение заявки',
      issue_cancelled: 'Заявка отменена',
      issue_done: 'Работа по заявке завершена',
      document_cancelled: 'Документ отменен',
      document_pending_cancellation: 'Документ ожидает отменены',
      document_rejected: 'Документ возвращен',
    }
  },
  documents: {
    taskDetail: {
      total: 'всего',
      done: 'завершено',
      expired: 'просроченно',
    },
    sourceTypes: {
      standalone: 'Вручную',
      document: 'Документ',
      document_resolution: 'Резолюция',
      document_plan: 'План мероприятий',
      project: 'Проект',
      program: 'Программа',
    },
    list: 'Список поручений',
    newDocument: 'Новое поручение',
    filters: {
      role: 'Роль',
      expiration: 'Истечение срока',
      state: 'Статус',
      priority: 'Приоритет',
      sourceType: 'Тип источника',
      type: 'Тип поручения',
      branch: 'Направление',
      project: 'Проект',
      source: 'Источник',
      docType: 'Тип документа',
      registerBook: 'Картотека',
    },
    fields: {
      title: 'Заголовок',
      project: 'Проект',
      state: 'Статус',
      term: 'Срок',
      tasks: 'Задачи',
      author: 'Автор',
      role: 'Роль',
      source: 'Источник',
      maintainer: 'Ответственный',
      legalDocNum: 'Номер документа основания',
      legalDocDate: 'Дата документа основания',
      sourceType: 'Тип источика',
      based_on_docs: 'Отображать поручения на основе документов',
    },
    infoDoc: 'Для сведения поручение',
    notViewedByMaintainer: 'Не просмотренно',
    viewedByMaintainer: 'Просмотренно',
    maintainer: 'Контролирующий',
    executive_maintainer: 'Ответственный исполнитель',
    executor: 'Исполнитель',
    executors: 'Исполнители',
    removeDocument: 'Удалить поручение',
    rejectDocument: 'Отменить поручение',
    rejectSubmition: 'Вы уверены, что хотите отменить поручение? Это действие нельзя будет отменить.',
    tasks: 'Задачи',
    attachments: 'Прикрепленные файлы',
    document: 'Документ',
    progress: 'Прогресс поручения'
  },
  tasks: {
    type: 'Тип',
    removeTask: 'Удалить задачу',
    rejectTask: 'Отменить задачу',
    rejectSubmition: 'Вы уверены что хотите отменить задачу? Это действие нельзя будет отменить.',
    guarantor: 'Поручитель',
    currentState: 'Текущий статус',
    termDate: 'Срок сдачи',
    progress: 'Прогресс задачи',
    inputNameToAddUser: 'Введите имя чтобы добавить пользователей',
    name: 'Имя',
    state: 'Статус',
    viewed: 'Просмотренно',
    notViewed: 'Не просмотренно',
    actions: 'Действия',
    position: `{position} в департаменте <b>{department}</b>`,
    executorsAddTip: 'Чтобы добавить исполнителей введите имя или департамент в строку поиска выше и выберите нужного сотрудника.',
    taskType: 'Тип задачи',
    term: 'Срок',
    addMeAsExecutor: 'Назначить меня исполнителем по умолчанию',
    termError: 'Укажите срок для задачи',
    showMy: 'Показать только мои',
    showExpired: 'Показать просроченные',
    create: 'Создать новую задачу',
    filters: {
      period: 'Период',
      expiration_period: 'Период просрочки'
    },
    periods: {
      week: '10 дней',
      month: '30 дней',
      year: 'C начала года',
    },
    ePeriods: {
      expired: 'Просроченно',
      expiring: 'Сегодня - завтра',
      expires_in_5_days: 'До 5 дней',
      expires_in_14_days: '6-14 дней',
      expires_after_14_days: 'Свыше 14 дней',
    }
  },
  announce: {
    list: 'Список анонсов',
    create: 'Новый анонс',
    title: 'Название'
  },
  employees: {
    username: 'Имя пользователя',
    chatNumber: '№ чата',
    actions: 'Действия',
    departmentList: 'Список подразделений',
    position: 'Должность',
    department: 'Департамент',
    birthday: 'Дата рождения',
    mobilePhone: 'Мобильный телефон',
    workPhone: 'Рабочий телефон',
    hiredDate: 'Дата найма',
    dismissalDate: 'Дата найма',
    category: 'Категория',
    workplace: 'Офис/Здание',
    about: 'О себе',
    workLoad: 'Кол-во штатных',
    level: 'Этаж',
    cabinet: 'Кабинет',
    profilePhoto: 'Фото профиля',
    interfaceSetups: 'Настройки системы',
    language: 'Язык интерфейса',
    telegramNotifications: 'Оповещения в Telegram мессенджере',
    documentPreview: 'Предпросмотр документа',
    telegramSessions: 'Сессии Telegram',
    noActiveSessions: 'У вас нет активных Telegram сессий.'
  },
  issueTracker: {
    list: 'Список заявок',
    notAssigned: 'Не назначен',
    newIssue: 'Новая заявка',
    incoming: 'Входящие',
    outgoing: 'Исходящие',
    expired: 'С истекшим сроком',
    expiring: 'Срок не истек',
    issue: 'Заявка',
    reject: 'Отменить заявку',
    author: 'Автор',
    executor: 'Исполнитель',
    priority: 'Приоритет',
    currentState: 'Текущий статус',
    category: 'Категория',
    term: 'Срок',
    progress: 'Прогресс заявки',
    rejectAcceptation: 'Вы уверены, что хотите отменить заявку? Это действие нельзя будет отменить.',
    file: 'Прикрепленный файл',
    downloadFile: 'Скачать прикрепленный файл',
  },
  projects: {
    list: 'Реестр проектов',
    create: 'Создать новый проект',
    title: 'Заголовок',
    sourceType: 'Тип источника',
    projectType: 'Тип проекта',
    branch: 'Направление/Программа',
    customer: 'Заказчик',
    beneficiary: 'Бенефициар',
    department: 'Отдел',
    budget: 'Плановый бюджет',
    planStartDate: 'Плановая дата начала',
    planEndDate: 'Плановая дата окончания',
    factStartDate: 'Фактическая дата начала',
    factEndDate: 'Фактическая дата окончания',
    maintainer: 'Ответственный',
    budgetError: 'Укажите плановый бюджет',
    spend: 'Фактически потрачено',
    legals: 'Основания',
    files: 'Файлы',
    state: 'Статус',
    phases: 'Фазы',
    financingSources: 'Источники финансирования',
    contractors: 'Подрядчики',
    spending: 'Освоение средств',
    issues: 'Задачи проекта',
  },
  reports: {
    nothingFound: 'Ничего не найдено',
    chooseDepartmentForReport: 'Выберите департамент для формирования отчета.',
    chooseDepartment: 'Выберите департамент',
    date: 'Дата',
    list: 'Список отчетов',
    startDate: 'Начало периода',
    endDate: 'Конец периода',
    department: 'Департамент',
    fullname: 'ФИО',
    documentsTasks: 'Указания/Задачи',
    notStarted: 'Не начато',
    inProgress: 'Выполняется',
    done: 'Выполнено',
    closed: 'Закрыто',
    total: 'всего',
    appealTotal: 'Обращений всего',
    expired: 'в т.ч. просроченно',
    documents: 'поручения',
    tasks: 'задачи',
    noDataAtSelectedDate: 'Данные на выбраную дату отстутсвуют, попробуйте выбрать другую дату.',
    userStats: {
      progress: 'в процессе',
      done: 'выполнено',
      expired: 'просрочено',
    },
    author: 'Автор',
    begin: 'Начало',
    end: 'Конец',
    state: 'Статус',
    registerBook1: 'Картотека 1',
    registerBook2: 'Картотека 2',
    registerBook3: 'Картотека 3',
    registerBook4: 'Картотека 4',
    appeals: 'Обращения',
    other: 'Прочие документы',
    incomingDocs: 'Входящие документы',
    innerDocs: 'Исходящие и внутренние документы',
    from: 'От',
    count: 'количество',
    docNumber: 'Номер документа',
    description: 'Описание',
    registeredDate: 'Дата регистрации',
    maintainer: 'Ответсвенное лицо',
    termDate: 'Срок исполнения',
    termDelay: 'Опоздание (в днях)',
    category: 'Категория',
    emtByStates: 'Исполнение в разрезе документов',
    emtByExpiration: 'Сроки исполнения',
    executiveAnalytics: 'Аналитика исполнения',
    activityAnalytics: 'Анализ активности пользователя по задачам',
    byStates: 'По статусам',
    byAD: 'По картотекам',
    daily: 'По дням',
    monthly: 'По месяцам',
  },
  resources: {
    available: 'Доступные ресурсы',
    createReservation: 'Резервация ресурса',
    begin: 'Начало',
    end: 'Конец',
    resource: 'Ресурс',
    reserve: 'Резервировать'
  },
  surveys: {
    possibleAnswer: 'Вар. ответа',
    list: 'Список опросов',
    answerToSave: 'Ответьте на все вопросы, чтобы сохранить',
    expire: 'окончание',
    results: 'Результаты',
    publish: 'Опубликовать',
    stop: 'Приостановить',
    isAnswered: 'Опрос пройден',
    resultsDescription: 'В опросе приняли участие {answeredEmployeesCount} из {employeesCount} сотрудников учавствовавших в опросе.',
    votes: '{count} голосов',
    title: 'Названия',
    endDate: 'Дата окончания',
    questions: 'Вопросы',
    questionText: 'Текст вопроса',
    single_option: 'Один',
    multi_option: 'Много',
    question_answer: 'Текст ответа',
    addVariant: 'Добавить вариант ответа',
    removeQuestion: 'Удалить вопрос',
    addQuestion: 'Добавить вопрос',
  },
  comments: {
    title: 'Комментарии',
    edited: 'отредактировано',
    noComments: 'Комментариев к показу нет.',
    inputComment: 'Введите комментарий',
    send: 'Отправить',
    remove: 'Удаление комментария',
    removeSubmission: 'Вы уверены, что хотите удалить данный комментарий? Это действие нельзя будет отменить.'
  },
  contractors: {
    counterpart: 'Контрагент',
    type: 'Тип участия',
    contractDate: 'Дата договора',
    contractNumber: 'Номер договора',
    contractAmount: 'Сумма договора',
    contractFile: 'Файл договора',
    create: 'Создать подрядчика',
  },
  financingSources: {
    source: 'Источник финансирования',
    percent: 'Процент финансирования',
    percentError: 'Процент фининансирования не может быть отрицательным',
    create: 'Создать новый источник финансирования',
  },
  issues: {
    type: 'Тип',
    priority: 'Приоритет',
    category: 'Категория',
    author: 'Автор',
    executor: 'Исполнитель',
    create: 'Создать новую задачу',
    title: 'Наименование',
    state: 'Статус',
    employee: 'Сотрудник',
    department: 'Отдел',
    term: 'Срок',
    startDate: 'Плановая дата начала',
    startedDate: 'Фактическая дата начала',
    completedDate: 'Дата окончания',
  },
  spending: {
    create: 'Создать новое освоение средств',
    contractor: 'Подрядчик',
    amount: 'Сумма освоения',
    date: 'Дата акта',
    number: '№ акта',
    file: 'Файл контракта'
  },
  docflow: {
    is_absent: 'Отсутствует',
    checkouts: 'Ознакомление',
    decisionType: 'Вид решения',
    parentDocument: 'Документ основание',
    close: 'Снять с контроля',
    checkouts_list: 'Список согласования',
    applicant: 'Данные заявителя',
    is_informational: 'Для сведения документ',
    is_classified: 'Для служебного пользования',
    is_pending_cancellation: 'В ожидании отмены',
    is_forwarded: 'Перенаправленный документ',
    is_group_appeal: 'Групповое обращение',
    attachRegistrationNumber: 'Зарегистрировать',
    signed: 'Подтверждено ЭЦП',
    checkout: {
      name: 'Имя',
      state: 'Статус',
      states: {
        new: 'Ожидание ознакомления',
        rejected: 'Отклонено',
        cancelled: 'Ознакомление отменено',
        checked_out: 'Ознакомлен',
        excluded: 'Исключен',
        not_checked: 'Не ознакомлен'
      }
    },
    resend_appeal: 'Перенаправить обращение',
    agree: 'Ознакомился',
    regNumberDoesNotExists: 'Документ',
    setPlanTitle: 'Изменить заголовок',
    planTitlePlaceholder: 'Введите заголовок',
    realisation_mechanisms: 'Механизмы реализации',
    approver: 'Утверждающий',
    planControlHelp: 'Закрытые / Выполненые / В процессе / Новые',
    plan: {
      name: 'Описание',
      realisation_mechanisms: 'Механизм реализации',
      maintainer: 'Ответственный',
      executors: 'Соисполнители',
      term: 'Срок',
    },
    maintainer: 'Ответственный',
    list: 'Список документов',
    sendForAgreement: 'Отправить на согласование',
    sendForApprove: 'Отправить на утверждение',
    pend: 'Согласовать',
    approve: 'Утвердить',
    register: 'Зарегистрировать',
    publish: 'Опубликовать',
    agreePlan: 'Согласовать план мероприятий',
    sureRemove: 'Вы уверены, что хотите удалить?',
    removePlanGroup: 'Вместе с группой удалятся все дочерние элементы.',
    removePlanItem: 'Это действие нельзя будет отменить.',
    executors: 'Исполнители',
    assignmentsTip: 'Поручения, основанные на данном документе, отсутствуют.',
    approveResolution: 'Утвердить резолюцию',
    sendToCreateResolution: 'Отправить на заполнение резолюции',
    editResolution: 'Править резолюцию',
    sendChangeRequest: 'Запрос на изменение',
    author: 'Автор',
    newDocument: 'Новый документ',
    informational: 'Документ для сведения',
    createPlanItem: 'Добавить пункт',
    createPlanGroup: 'Добавить группу',
    resolution: 'Резолюция',
    noPlanItemsExist: 'Нет пунктов для отображения, вы можете создать их нажав на кнопку "Добавить пункт" выше.',
    planOrderNumber: 'Порядковый номер',
    termDate: 'Срок',
    planGroup: 'Группа',
    maintainerType: 'Тип ответственного',
    organization: 'Организация',
    department: 'Департамент',
    maintainer_organization: 'Ответственная организация',
    maintainer_department: 'Ответственный департамент',
    noPlanMaintainer: 'Не назначен',
    noPlanExecutors: 'Назначить исполнителей',
    documentPlan: 'План мероприятий',
    createResolution: 'Создать резолюцию',
    noResolution: 'Резолюция отсутствует.',
    resolutionTemplates: 'Шаблоны резолюции.',
    attachments: 'Прикрепленные файлы',
    planControl: 'Контроль исполнения ПМ',
    assignmentsControl: 'Связанные поручения',
    relatedDocumentsControl: 'Связанные документы',
    progress: 'Прогресс',
    addNewCorespondent: 'Добавить внешнего корреспондента "{name}"',
    correspondents: 'Получатели',
    correspondentsAddTip: 'Начните вводить название корреспондента в поле выше, чтобы добавить их в список.',
    inputNameToAdd: 'Введите название, чтобы найти и добавить',
    excludeExternalCorrespondents: 'Искать только внутри объектов системы',
    correspondent: {
      name: 'Получатели'
    },
    docTypes: {
      incoming: 'Входящие',
      outgoing: 'Исходящие',
      internal: 'Внутренние',
      appeals: 'Обращения',
      appeal: 'Обращения',
    },
    fullDocTypes: {
      incoming: 'Входящий документ',
      outgoing: 'Исходящий документ',
      appeal: 'Обращение'
    },
    fields: {
      resolution_maintainer: 'Ответственный исполнитель',
      supervisor: 'Контролирующий',
      resolution_term_date: 'Срок исполнения резолюции',
      registration_number: 'Регистрационный номер',
      description: 'Описание',
      category: 'Категория',
      registered_date: 'Дата регистрации',
      type: 'Тип документа',
      term_date: 'Срок исполнения',
      file: 'Файл документа',
      is_informational: 'Для информации',
      resolution_author: 'Автор резолюции',
      delivery_type: 'Вид доставки',
      original_document_number: 'Оригинальный номер',
      original_document_date: 'Дата оригинала документа',
      resolution: 'Резолюция',
      resolution_approver: 'Утверждающий резолюцию',
      register_book: 'Картотека',
      sender: 'Отправитель',
      appealType: 'Тип обращения',
      applicantType: 'Тип заявителя',
      applicant_name: 'ФИО заявителя',
      applicant_passport_number: 'Серия и № паспорта',
      applicant_work_phone: 'Рабочий телефон',
      applicant_mobile_phone: 'Мобильный телефон',
      applicant_region: 'Регион',
      applicant_area: 'Район',
      applicant_address: 'Адресс',
      applicant_company_name: 'Наименование организации',
      is_classified: 'Для служебного пользования',
      is_group_appeal: 'Групповое обращение',
      is_repeated_appeal: 'Повторное обращение',
      appeal_sender: 'Перенаправившая организация',
      appeal_category: 'Категория обращения',
      spotter: 'Корректировщик',
      lawyer: 'Юрист'
    },
    appealTypes: {
      statement: 'Заявление',
      complaint: 'Жалоба',
      proposal: 'Предложение',
      thank: 'Благодарность',
      anonymous: 'Аноним'
    },
    applicantTypes: {
      individual_person: 'Физическое лицо',
      legal_person: 'Юридическое лицо'
    },
    categories: {
      incoming: 'Входящий',
      outgoing: 'Исходящий',
    },
    incomingTip: 'Оригинальный документ {name} от {date}',
    workflow: {
      title: 'Поручение',
      name: 'Наименование поручения',
      term_date: 'Срок',
    },
    filters: {
      state: 'Статус',
      is_expired: 'Просроченные',
      is_informational: 'Для сведения',
      is_classified: 'Для служебного пользования',
      created_date_from: 'Дата создания с',
      created_date_to: 'Дата создания по',
      term_date_from: 'Дата срока с',
      term_date_to: 'Дата срока по',
      is_repeated_appeal: 'Повторное обращение',
      is_group_appeal: 'Групповое обращение',
      applicant_type: 'Тип заявителя',
    },
    changeRequest: {
      title: 'Запрос на изменение',
      downloadFile: 'Скачать извещение',
      file: 'Извещение'
    }
  },
  dashboard: {
    title: 'Рабочая среда',
    common_items: 'На повестке дня',
    in_process_items: 'В процессе',
    expired_items: 'С истекшим сроком',
    controlled_items: 'На контроле',
    extended: {
      common_documents: 'На повестке дня',
      expired_documents: 'С истекшим сроком',
      controlled_documents: 'На контроле',
    },
    emptyList: 'Документов в данной категории нет',
    announcements: 'Анонсы',
    itemTypes: {
      incoming_document: 'Входящий документ',
      outgoing_document: 'Исходящий документ',
      appeal_document: 'Обращение',
      assignment: 'Поручение',
      task: 'Задача'
    },
    sort: {
      dateAsc: 'Дате (сначала новые)',
      dateDesc: 'Дате (сначала старые)',
      priorityAsc: 'Важности (сначала важные)',
      priorityDesc: 'Важности (сначала неважные)',
    }
  },
  admin: {
    name: 'Название',
    parent: 'Родитель',
    abbr: 'Абревиатура',
    registerBook: 'Картотека',
    weight: 'Приоритет',
    post_name: 'Должность',
    inn: 'ИНН',
    department: 'Департамент',
    category: 'Категория',
    maintainer: 'Ответственный',
    docTypeCategory: {
      incoming: 'Для входящих',
      outgoing: 'Для исходящих',
      appeal: 'Для обращений',
    },
    employee_name: 'Имя',
    last_name: 'Фамилия',
    patronymic: 'Отчество',
    initials: 'Инициалы',
    gender: 'Пол',
    male: 'Мужской',
    female: 'Женский',
    birthday: 'Дата рождения',
    mobile_phone: 'Мобильный телефон',
    work_phone: 'Рабочий телефон',
    hired_date: 'Дата найма',
    dismissal_date: 'Дата увольнения',
    is_dismissed: 'Уволен?',
    workplace_office: 'Офис/Здание',
    workplace_level: 'Этаж',
    workplace_cabinet_number: 'Кабинет',
    position: 'Должность',
    userData: 'Данные пользователя',
    login: 'Логин',
    password: 'Пароль',
    password2: 'Подтверждение',
    bio: 'Биография',
    passwordsWrong: 'Введеные пароли не совпадают',
    analytic_dimension: 'Аналитическая группа',
  },
  notFound: {
    subtitle: 'Объект не найден',
    description: 'Данный объект был удален или более вам не доступен',
    goBack: 'Вернуться назад'
  },
  direct: {
    doneDay: 'День завершения',
    question: 'Вопрос',
    mail_date_index: 'Дата и индекс приложенного письма',
    registration_date_index: 'Дата и индекс регистрации',
    control_type: 'Тип контроля',
    progress: 'Ход выполнения',
    receiver_and_date: 'Получатель и дата',
    progress_date: 'Дата поручения',
    sent_to: 'Куда отправленно',
    control_sign: 'Признаки контроля',
    progress_index: 'Индекс выполнения',
    executor_sign: 'Подпись исполнителя',
    removed_from_control: 'Снято с контроля',
    control: 'Контроль',
    no: 'Нет',
    qr: 'Проверить подлинность данного документа с помощью QR кода',
    term: 'срок',
  },
  globalSearch: {
    documents: 'Документы',
    assignments: 'Поручения',
    employees: 'Сотрудники',
  },
  regions: {
    krk: 'Республика Каракалпакстан',
    and: 'Андижан',
    bkh: 'Бухара',
    jzh: 'Жиззах',
    ksh: 'Кашкадарья',
    nvo: 'Наваи',
    nmg: 'Наманган',
    smr: 'Самарканд',
    srd: 'Сырдарья',
    srh: 'Сурхандарья',
    tshr: 'Ташкентская о.',
    tshc: 'г. Ташкент',
    frg: 'Фергана',
    khr: 'Харезм',
    other: 'Остальные',
  },
  employeeDetail: {
    floor: 'этаж',
    cabinet: 'кабинет',
  },
  errors: {
    chooseFileType: 'Выберите тип загружаемого документа',
    chooseFile: 'Выберите файл',
    noPossibleAnswer: 'В вопросе должен быть как минимум один вариант ответа',
    noQuestion: 'В опросе должен быть как минимум один вопрос',
    undefined: 'Не возможно выполнить действие',
    organizationNotFound: 'Проверьте введенные данные или обратитесь к администратору для добавления новой организации',
  },
  sign: {
    incorrectPassword: 'Неверный пароль ключа ЭЦП.',
    eimzoNotFound: 'Модуль E-IMZO не установлен или выключен.',
    keyNotFound: 'Не найден ключ ЭЦП для подписи документа.'
  }
}
